const colors = {
  primcol: "#0a599e",
  seccol: "#da222b",
  greycol: "#939598",
  midblcol: "#5b7aa6",
};

export default colors;
